import {
  getDeeplyNestedValue,
  getDeviceCategoryForMcBimItem,
  getMcbimItemClassificationInput,
} from "@multiconsult-group/multiplacer-core";
import {
  ISpaceValidation,
  SPACE_VALIDATION_ID_ENUM,
  SPACE_VALIDATIONS,
} from "../spaceValidationsUtils";

import { IDevice, IDeviceCategoryEnum, IMcBimItem } from "@multiconsult-group/multiplacer-core";

export interface ICompareItem {
  compCode: string;
  compDescription: string;
  deviceType: IDeviceCategoryEnum;
  countInStdRom: number;
  countInRoom: number;
  diff: number;
}

interface ICompCodeDescriptionDeviceType {
  compCode: string;
  compDescription: string;
  deviceType: IDeviceCategoryEnum;
  count: number;
}

interface IGetCompCodeArgs {
  mcbimItems: IMcBimItem[];
  compCodePath: string;
}

const getCompCodeDescriptionDeviceType = (
  args: IGetCompCodeArgs
): ICompCodeDescriptionDeviceType[] => {
  return args.mcbimItems.reduce((acc, item) => {
    const deviceType = getDeviceCategoryForMcBimItem(
      getMcbimItemClassificationInput({
        mcbimItem: item,
        compCodePath: args.compCodePath,
      })
    );
    if (deviceType != null) {
      const compCode = getDeeplyNestedValue(item, args.compCodePath);
      if (compCode != null) {
        const existingItem = acc.find(
          (accItem: ICompCodeDescriptionDeviceType) => accItem.compCode === compCode
        );
        if (existingItem != null) {
          existingItem.count += 1;
        } else {
          acc.push({
            compCode,
            compDescription: item.type?.name ?? "",
            deviceType,
            count: 1,
          });
        }
      }
    }
    return acc;
  }, [] as ICompCodeDescriptionDeviceType[]);
};

interface ICompareDeviceArgs {
  devices: IDevice[];
  mcbimItemsInStandardSpace: IMcBimItem[];
  compCodePath: string;
}

export const compareDevicesInStandardroom = (args: ICompareDeviceArgs): ICompareItem[] => {
  const compCodesCountInStdRoom = getCompCodeDescriptionDeviceType({
    mcbimItems: args.mcbimItemsInStandardSpace,
    compCodePath: args.compCodePath,
  });
  return compCodesCountInStdRoom.map((item) => {
    const countInStdRom = args.mcbimItemsInStandardSpace.filter(
      (mcbimItem) => getDeeplyNestedValue(mcbimItem, args.compCodePath) === item.compCode
    ).length;
    const countInRoom = args.devices.filter((device) => device.compCode === item.compCode).length;
    return {
      compCode: item.compCode,
      compDescription: item.compDescription,
      deviceType: item.deviceType,
      countInStdRom: countInStdRom,
      countInRoom,
      diff: countInStdRom - countInRoom,
    };
  });
};

interface IGetStandardRoomSpaceValidationArgs {
  devices: IDevice[];
  mcbimItemsInStandardSpace: IMcBimItem[];
  compCodePath: string;
}

export const getStandardRoomSpaceValidation = (
  args: IGetStandardRoomSpaceValidationArgs
): ISpaceValidation => {
  const compareItems = compareDevicesInStandardroom({
    devices: args.devices,
    mcbimItemsInStandardSpace: args.mcbimItemsInStandardSpace,
    compCodePath: args.compCodePath,
  });
  const diff = compareItems.reduce((acc, item) => acc + -Math.abs(item.diff), 0);
  const spaceValidation = SPACE_VALIDATIONS.find(
    (validation) => validation.id === SPACE_VALIDATION_ID_ENUM.STANDARD_ROOM
  ) as ISpaceValidation;
  return {
    ...spaceValidation,
    status: diff === 0 ? "VALID" : "WARNING",
    errorText:
      diff === 0
        ? undefined
        : `Rommet inneholder ${diff} enheter enn det som er definert i standardrommet`,
  };
};
